import ajax from '@/utils/ajax';

export const head = '/web';

// 获取access-token
export const reqSchemeUrl = (data) => ajax(`${head}/v1/wx/ma/generate/url-scheme`, data, 'POST');
